import { IIndexable } from "../../types/apiRequest/IIndexable.interface";

export const queryStringBuilder = (obj: IIndexable) => {
  const params = new URLSearchParams(obj);
  return params;
};
